const TempoMedio = ({ tempo }) => {
  return (
    <div className="bg-white rounded-2xl shadow p-4 text-center">
      <p className="text-sm text-gray-500">Tempo médio por visita</p>
      <p className="text-2xl font-bold text-blue-600">
        {tempo == "NaNm NaNs" ? 0 : tempo}
      </p>
    </div>
  );
};

export default TempoMedio;
